import React, { useEffect, useState } from 'react'
import {  useBnsMeiJieUpdateQuery } from '../../store/ReactWebSiteApi';
import { Descriptions, Space, Spin } from 'antd';
import DocTitle from '../../cpn/DocTitle';
import MediaEdit from './MediaEdit';
import DocList from './DocList';
function MediaDesc(props) {
    const [info,setInfo] = useState({
      bmj_name:''
    })
    const {data,isSuccess} = useBnsMeiJieUpdateQuery({bmj_id:props.bmj_id},{skip:!props.bmj_id})
    useEffect(() => {
        if(isSuccess){
            if(data.Status==='success'){
                console.log(data);                        
                setInfo({
                    bmj_dept_id:data.Result.bmj_dept_id,        
                    bmj_dept_name:data.Result.bmj_dept_name,                        
                    bmj_ctime:data.Result.bmj_ctime,                                       
                    bmj_cname:data.Result.bmj_cname,                                       
                    bmj_riqi:data.Result.bmj_riqi,                                                
                    bmj_name:data.Result.bmj_name,                                                
                    bmj_content:data.Result.bmj_content,                                                
                })
                // console.log(array);
                
            }
        }
    },[data, isSuccess])

    const items = [
        {
            key:'4',
            label:'名称',
            children:info.bmj_name,
            contentStyle:{fontSize:"18px"},
            span:3
        },
       
        {
            key:'bmj_content',
            label:'备注',
            children:<div  dangerouslySetInnerHTML={{__html:info.bmj_content}}></div>,
            contentStyle:{fontSize:"18px"},
            span:3
        },
        {
            key:'wendang',
            label:'文档',
            children:   <DocList 
                            bmj_dept_id={info.bmj_dept_id}
                            bmj_dept_name={info.bmj_dept_name}
                            bmj_id={props.bmj_id}
                            bmj_name={info.bmj_name}
                        />,
            contentStyle:{fontSize:"18px"},
            span:3
        },
       
        {
            key:'7',
            label:'部门',
            children:<>{info.bmj_dept_name}</>,
            labelStyle:{width:'120px'},
            contentStyle:{fontSize:"18px"}
        },
        {
            key:'8',
            label:'新增时间',
            children:info.bmj_cname+info.bmj_ctime,
            contentStyle:{fontSize:"18px"},
        },
        {
            key:'9',
            label:'操作',
            children:   <Space>
                              <MediaEdit
                                  bmj_id={props.bmj_id}
                              />  
                        </Space>,
        },
    ]
    return (
        <>
            {info.bmj_ctime ? <div 
                                    style={{border:'2px solid #eee',margin:"10px",padding:'20px'}}
                                >
                                   <DocTitle
                                        name='媒介'
                                        num={props.bmj_id}                        
                                    />                                    
                                    <Descriptions
                                        items={items}
                                        bordered
                                    />
                                </div>:  <Spin  size='large' />}
        </> 
    )
}

export default MediaDesc